var render = function render(){var _vm=this,_c=_vm._self._c;return _c('doughnut',{attrs:{"height":_vm.height,"chart-data":_vm.data,"chart-options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }